import ConfirmationSnapshot from '../../ConfirmationSnapshot/ConfirmationSnapshot';
import CheckMark from '../../../Shared/CheckMark/CheckMark';
import config from '../../../../config/config';
import { appendBasePath } from '../../../../utils/nav.utils';
import Button from '../../../Shared/Button/Button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../../redux/modules/authentication/authentication.module.selectors';
import {
  getHasMutualFundPaperlessConfirmations,
  getPaperlessInfo,
} from '../../../../redux/modules/user/Paperless/paperless.selectors';
import QCDWhatsNext from '../../WhatsNext/QCD/QCDWhatsNext';
import { ButtonType } from '../../../Shared/Button';
import './QCDConfirmation.scss';
//import { PrintConfirm } from '../../PrintConfirm/PrintConfirm';
import { getDeliveryMethod } from '../../../../redux/modules/sellDeliveryMethod/sellDeliveryMethod.selectors';
import { CONFIRM_PATH_SUFFIX } from '../../../../settings/settings';
import { getQCDTransaction } from '../../../../redux/modules/qcd/qcd.selectors';
import { useHistory } from 'react-router-dom';
import { formatUTCDate } from '../../../../utils/dates/date-utility';
import { QCDPrintPDF } from '../../../../redux/modules/qcd/qcd.module';

export const QCDConfirmation = () => {
  const customerWebViewEnabled = useSelector(isCustomerWebViewEnabled);
  const deliveryMethod = useSelector(getDeliveryMethod);
  const isSalesforceRepEnabled = useSelector(isSalesforceRep);
  const hasMutualFundPaperlessConfirms = useSelector(
    getHasMutualFundPaperlessConfirmations
  );
  const paperlessInfo = useSelector(getPaperlessInfo);
  const qcdTransaction = useSelector(getQCDTransaction);
  const history = useHistory();
  const { pathname } = window.location;
  if (qcdTransaction.length === 0 && pathname.endsWith(CONFIRM_PATH_SUFFIX)) {
    history.push(
      pathname.substr(0, pathname.length - CONFIRM_PATH_SUFFIX.length)
    );
  }
  const RawTradeDates = qcdTransaction[0]?.distributionDetails
    ? Object.values(qcdTransaction[0]?.distributionDetails)
        ?.flat()
        .map((transaction) => {
          return { tradeDate: transaction.tradeDate };
        })
    : [{}];

  const tradeDate = RawTradeDates[0]?.tradeDate;
  const confNum = qcdTransaction[0]?.confirmationNumber;
  const qcdId = qcdTransaction[0]?.qcdId;
  const dispatch = useDispatch();
  return (
    <div className="sell-confirmation-page">
      <div className="sell-confirmation-background-design">
        <span className="sell-confirmation-background-design-inner" />
        <span className="sell-confirmation-background-design-watermark" />
      </div>
      <div className="container">
        <div className="sell-confirmation-container row">
          <div className="col-xs-12 col-sm-7 col-md-8 sell-confirmation-submit-text">
            <div className="sell-confirmation-heading">
              Your QCD has been submitted!
            </div>
            <div className="sell-confirmation-subheading">
              <strong>Note: </strong>We will send you an{' '}
              {hasMutualFundPaperlessConfirms || paperlessInfo.updatedPaperless
                ? 'email'
                : 'mail'}{' '}
              indicating we received your request for this transaction(s). After
              the transaction(s) are completed, we will send you a Confirmation
              of Activity.
            </div>
            {!(!customerWebViewEnabled && isSalesforceRepEnabled) && (
              <div className="print-confirm-container">
                <Button
                  buttonType="primary"
                  className="print-confirm-button"
                  type="button"
                  onClick={() => {
                    dispatch(QCDPrintPDF(qcdId));
                  }}
                >
                  <img
                    alt=""
                    src="../../../assets/images/Group.svg"
                    className="print-confirm-icon"
                  />
                  <span> Print Confirmation Details </span>
                </Button>
              </div>
            )}
          </div>
          <div className="col-xs-12 col-sm-5 col-md-4">
            <ConfirmationSnapshot
              isSalesforceRep={isSalesforceRepEnabled}
              customerWebViewEnabled={customerWebViewEnabled}
              confirmationNumber={confNum}
              deliveryMethod={deliveryMethod}
              id="confirmation-snapshot"
              successIcon={
                <CheckMark className="sell-confirmation-checkmark" />
              }
              tradeDate={formatUTCDate(tradeDate, 'MM/DD/YYYY')}
              transactions={RawTradeDates}
            />
          </div>
        </div>
        <span>
          {!(!customerWebViewEnabled && isSalesforceRepEnabled) && (
            <div className="sell-confirmation-mobile-buttons">
              <a href={`${config.url}${appendBasePath('/landing')}`}>
                <Button buttonType={ButtonType.SECONDARY_GHOST}>
                  Make Another Transaction
                </Button>
              </a>
              <a href={`${config.url}/usis/my-accounts/dashboard`}>
                <Button buttonType={ButtonType.SECONDARY_GHOST}>
                  Go to Dashboard
                </Button>
              </a>
            </div>
          )}
          {!customerWebViewEnabled && isSalesforceRepEnabled ? (
            <div className="qcd-whats-next-con" />
          ) : (
            <QCDWhatsNext />
          )}
        </span>
        <p
          style={{
            color: '#000',
            position: 'relative',
            bottom: '5px',
          }}
        >
          2847130
        </p>
      </div>
    </div>
  );
};
export default QCDConfirmation;
